// Generated by CoffeeScript 2.7.0
var LabelListItem;

export default LabelListItem = Vue.extend({
  props: {
    initialLabel: {
      type: String
    },
    index: {
      type: Number
    }
  },
  data: function() {
    return {
      valid: true,
      label: this.initialLabel
    };
  },
  template: `<div class="form-field-group inline mb-4 label_list_item">
  <div class="form-field required"
      :class="{ 'has-error': !valid }">
    <div class="form-field-input-container">
      <div class="form-field-input">
        <input class="form-field-value"
              placeholder="请输入级联选择名称"
              type="text"
              v-model.trim="label"
              @blur="blurFunc">
      </div>
      <div class="message">不能为空</div>
    </div>
  </div>
  <button class="text-btn btn-danger"
          @click="deleteLabel">删除</button>
</div>`,
  watch: {
    label: function(val) {
      return this.$emit('labelChanged', this.index, val);
    }
  },
  methods: {
    blurFunc: function() {
      return this._validate();
    },
    deleteLabel: function() {
      return this.$emit('deletedLabel', this.index);
    },
    _validate: function() {
      return this.valid = Boolean(this.label);
    }
  }
});
